import { Card } from 'flowbite-react';
import React from 'react';
import p1 from '../../Media/card/p1.jpg'
import p2 from '../../Media/card/p2.jpg'
import p3 from '../../Media/card/p3.jpg'

const Section7 = () => {
    return (
        <div className='w-10/12 mx-auto my-5 grid grid-cols-12 gap-5 justify-between'>
            <div className="max-w-sm md:col-span-4 col-span-12">
                <Card imgSrc={p1}>
                    <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                        EUA: Pfizer-BioNtech Covid-19 Vaccine for Children Ages 5-11
                    </h5>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                        Emergency Use Authorization The CDC now recommends the Pfizer-BioNTech COVID-19 vaccine (BNT162b2) for children ages 5-11 years after the FDA’s EUA approval and support from the Advisory Committee on Immunization Practices (ACIP). The authorization is based on data...
                    </p>
                    <p className='text-xl text-left text-primary-600'>Read More</p>
                </Card>
            </div>


            <div className="max-w-sm md:col-span-4 col-span-12">
                <Card imgSrc={p2}>
                    <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                    Omicron Variant – Preliminary Findings
                    </h5>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                        Emergency Use Authorization The CDC now recommends the Pfizer-BioNTech COVID-19 vaccine (BNT162b2) for children ages 5-11 years after the FDA’s EUA approval and support from the Advisory Committee on Immunization Practices (ACIP). The authorization is based on data...
                    </p>
                    <p className='text-xl text-left text-primary-600'>Read More</p>
                </Card>
            </div>


            <div className="max-w-sm md:col-span-4 col-span-12">
                <Card imgSrc={p3}>
                    <h5 className="text-2xl font-bold tracking-tight text-primary-600">
                        Peripheral Nerve Blocks for Headaches in the ED
                    </h5>
                    <p className="font-normal text-gray-700 dark:text-gray-400">
                        Emergency Use Authorization The CDC now recommends the Pfizer-BioNTech COVID-19 vaccine (BNT162b2) for children ages 5-11 years after the FDA’s EUA approval and support from the Advisory Committee on Immunization Practices (ACIP). The authorization is based on data...
                    </p>
                    <p className='text-xl text-left text-primary-600'>Read More</p>
                </Card>
            </div>

        </div>
    );
};

export default Section7;